export default {
  // 学历
  edu: 'DAC77C71-8062-44BD-8CD8-9EFE04FA8D65',
  // 学位
  degree: '2FB1B1BD-91A1-4F4D-C5B4-1B9563422696',
  // 职称
  title: '6FA9D0F2-E138-48EE-86D4-822867ED318A',
  // 级别
  level: 'D4CCE94C-9095-481B-AC05-785EF0550E3A',
  // 专业
  specialty: '10273439-65F9-45BF-8AF0-3E8F5D28377D',
  // 用户类型
  usertype: '2209C215-F175-4FC9-B631-C22B4F61461A',
  // 通知类型
  noticetype: '706B6507-655B-4CDE-9F71-ACECF82F2752',
  //快捷操作
  quickOperation: 'CF286CFE-68D6-4DB9-A013-9AB24D62CE0E',
  //出差类别
  businessclass: '3ECF3806-FAB9-4680-8B13-B39BB9AB783C',
  //活动类型
  plantype: "8A407557-1ADE-15A6-9397-7EC16F209FBD",
  //学员
  planusertype: "F146D984-5189-BF42-D260-31732159D6C0",
  //评分表类型
  scoretabletype: "5FCC7D48-8724-7A89-948F-86079DBC49DB",
  //合同类型
  contractType: "9D0E21F3-2D1E-3DEB-1330-06B30333A578",
  //项目类型
  projectType: "123723DC-CAD9-4990-EBAF-CEAEFE093F1F",
  //项目级别-S020
  projectLevel: "33C47334-C47D-3EC9-3E3A-2D36F05CD5A5",
  //项目来源-S020
  projectSource: "81EF3D44-7D19-2402-DCCE-B269048E468A",
  //项目学科-S020
  projectDiscipline: "9D1BC337-7DDB-3704-9A82-990638DD2942",
  //项目专业
  projectMajor: "23308CCC-4D52-C0F7-8D79-EDD725FE7228",
  //文件类型-S064
  fileType: "D97FF652-2E14-B0D3-1ED3-F0F67CCF216D",
  //制度类型-S064
  ruleType: "8DD77EDA-BF05-DF83-45A6-48AA23A49FB2",
  //指标类型-S061
  indexType: "383B613F-E2DC-2134-08C9-72180B04346D",
  //培训对象-S014
  trainStuType: "FC5B2839-41B2-F791-64F6-71DB85598AD8",
  //进修类型-S014
  studyType: "A42724AD-DC95-C28C-6019-0B71F81438B4",
  //进修专业-S014
  studySpecialty: "7D9C7927-E688-E506-51F8-45B3DCC6291C",
  //规培专业-S014
  standardTrainSpecialty: "4C39D6EB-9A05-DF5C-3EBC-B151CBDD8A79",
  //成果类型-S065
  studioResultsType: "B540E017-424C-86B9-59B9-CC23FE78E542",
  //成果级别-S065
  studioResultsLevel: "168F8138-9ED1-0821-72EA-02904618DEDC",
  //教学类型-S065
  studioTeachingType: "D4121E12-9E97-4113-0056-14429E520C4B",
  //现岗位级别-S012
  titleAppointStationLevel: "d755a949-bb45-d7f8-f275-6548fc7dc696",
  //专业职级-S012
  titleAppointTitleLevel: "5e9f4efc-9623-e106-92aa-2a6c268e3b75",
  //荣誉类别/级别-S012
  honorLevel: "0c0f42fa-9d97-9043-a8cd-e55846c11ffa",
  //专业技术职务-S008
  tecMajorPost: "796EF349-3A62-932B-88D1-C995162A71D2",
  //证书级别-S008
  tecCertLevel: "7CB7EFE3-82BB-1DD7-74F2-C3EE1DF95E30",
  //证书类型-S008
  tecCertType: "FA0F00E5-9992-0702-8D72-9FD0180F7CBF",
  //高级教学职称-S008
  tecTeachingTitle: "B45612E7-DBC7-7255-1E08-A42FC01D5661",
  //导师类型-S008
  tecGraduateTutorType: "6254BE14-B9FE-4783-B41D-A4DB9A41FF12",
  //学会-S008
  learnTenure: "854B9F31-8CDB-DEC0-ACD5-22E6C35991BF",
  //任职类型-S008
  learnTenureType: "4D6312C6-4450-26A8-39BB-3896D4CA9A12",
  //任职状态-S008
  learnTenureStatus: "297A876A-BEFC-4640-09A8-7275D1218EAC",
  //事故类型-S015
  medicalAccidentType:"8BFEE2F6-3D5F-6885-EB62-A8C6AD3C5723",
  //纠纷类型-S015
  medicalDisputesType:"5E4843C4-4AF8-79A9-A7E3-AAFFF65189DE",
  //授权类型-S015
  authorizationType:"E3B70340-0621-196C-9D42-5E7DAFA4B840",
  //活动类型-S015
  medicalActivitiesType:"5E8AE298-AA18-9306-BDFF-44CAFE62DF86",
  //基地-S008
  majorBase:"4FDB144B-4050-3F87-ED9A-5FAB946479D0",
  //教研室-S008
  tecDepartment:"DFF4A0F1-C1F5-7600-9E11-994C217F8788",
  //作者属性-S013
  authorAttribute:"146FFDF7-DA6C-EDBD-76D8-C62E8921EF13",
  //项目类型-S013
  techniqueProjectType:"8D1B5773-3DFB-7D94-B663C2D5F0332EC7",
  //论文类别-S013
  papersThesisCategory:"C058A896-AFCA-4184-61C5-AB915EDF698D",
  //会议类型-S013
  activitiesMeetingType:"6AE654C9-2B88-BD58-589E5C59E5ED20AE",
  //大科-S003
  majorDepartment:"96D47F3C-D912-5FDF-5972-F92BB0F2D144",
  //要求类型-S003
  requeireType:"BA82C6FD-2197-D071-4362-3BA3FEDC16E4",
  //届别-S000
  sessionLevel:"9261F186-14F0-C449-941F-0BF601E1E64B",
  //执行技能 - S010
  execuTiveSkills:"56C3ECB8-BF06-2DF1-BAF1-EC882C924CB0",
  // 民族
  nation: 'DAC77C71-8062-44BD-8CD8-9EFE04FA8D65',
  //药物规格
  ywgg: '6FA9D0F2-E138-48EE-86D4-822867ED318A',
  // 用量
  yl: 'D4CCE94C-9095-481B-AC05-785EF0550E3A',
  // 用法
  yf: '10273439-65F9-45BF-8AF0-3E8F5D28377D',
  // 给药途径
  gytj: '2209C215-F175-4FC9-B631-C22B4F61461A',
  //检查表名
  jctable:'0161E98B-550A-4F0C-B69C-136981DDCCD0'
}
